import ItemsHeader from "../ItemsHeader";
import SortSelect from "../../../containers/common/SortSelect";
import ItemCount from "../../../containers/common/SavedItemsItemCount";

const SavedItemsItemsHeader = () => (
  <ItemsHeader>
    <SortSelect />
    <ItemCount />
  </ItemsHeader>
);

export default SavedItemsItemsHeader;
